import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'
import { playDummyAudio } from '../utils'

// Connects to data-controller="pickup"
export default class extends Controller {
  static values = { url: String }

  static startPageX
  static startPageY

  startClick(e) {
    this.startPageX = e.pageX
    this.startPageY = e.pageY
  }

  endClick(e) {
    if (this.isClick(e.pageX, e.pageY)) {
      this.play()
    }
  }

  play() {
    playDummyAudio()
    Turbo.visit(this.urlValue)
  }

  isClick(pageX, pageY) {
    return Math.abs(this.startPageX - pageX) < 5 && Math.abs(this.startPageY  - pageY) < 5
  }
}
